module.exports = __webpack_public_path__ + "img/FileUpload.a3bd40b0.svg";